export { default } from './InstagramIcon';
